<script setup="">
import { computed, inject } from "vue";

const emit = defineEmits(["click"]);

const props = defineProps({
  classes: {
    type: String,
    required: false
  }
});

const close = inject("close");
const twMerge = inject("twMerge");

const classes = computed(() =>
  twMerge(
    "block h-12 w-full text-sm+ font-semibold hover:bg-zinc-100 active:bg-zinc-200 dark:bg-zinc-800 dark:hover:bg-zinc-800/70 dark:active:bg-zinc-800/20",
    props.classes
  )
);

const handleClick = ($event) => {
  emit("click", $event);
  close();
};
</script>

<template>
  <button :class="classes" @click="handleClick">
    <slot />
  </button>
</template>
